/* SherpaHolidays: Meta-only bridge for an accepted PerfectBook inquiry.
 * The form, its existing Google listener and Shopify's pixel stay unchanged.
 */
(function () {
  'use strict';
  try {
    if (window.__shMetaLeadBridge) return;
    var pixelId = '1814728372876400';
    var seen = new Set();

    function consentAllowed() {
      try {
        if (document.cookie.split(';').some(function (part) {
          return part.trim() === 'hldn_consent_choice=declined';
        })) return false;
        var privacy = window.Shopify && window.Shopify.customerPrivacy;
        return !!privacy && privacy.marketingAllowed() === true &&
          privacy.analyticsProcessingAllowed() === true &&
          privacy.saleOfDataAllowed() === true;
      } catch (_) { return false; }
    }

    function pixelReady() {
      try {
        if (typeof window.fbq !== 'function' ||
            typeof window.fbq.getState !== 'function') return false;
        var state = window.fbq.getState();
        return !!state && Array.isArray(state.pixels) &&
          state.pixels.some(function (pixel) { return pixel.id === pixelId; });
      } catch (_) { return false; }
    }

    document.addEventListener('sherpa:inquiry_submitted', function (event) {
      try {
        var submissionId = event.detail && event.detail.submission_id;
        if (typeof submissionId !== 'string' || !submissionId.trim() ||
            seen.has(submissionId) || !consentAllowed()) return;
        seen.add(submissionId);
        var deadline = Date.now() + 30000;

        function attempt() {
          try {
            if (Date.now() > deadline || !consentAllowed()) return;
            if (pixelReady()) {
              window.fbq('trackSingle', pixelId, 'Lead', {}, {
                eventID: submissionId
              });
              return;
            }
            if (Date.now() < deadline) window.setTimeout(attempt, 200);
          } catch (_) { /* Fail closed without affecting the form or Google. */ }
        }
        attempt();
      } catch (_) { /* A malformed event must not affect other listeners. */ }
    });
    window.__shMetaLeadBridge = true;
  } catch (_) { /* Initialization failures must not affect the storefront. */ }
})();
